import * as tslib_1 from "tslib";
/* istanbul ignore next */
var BaseBetsApiClient = /** @class */ (function () {
    function BaseBetsApiClient(configuration, ajaxService) {
        this.ajaxService = ajaxService;
        this.configuration = configuration;
    }
    BaseBetsApiClient.prototype.getFetchOptions = function (request) {
        return {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + this.configuration.accessToken,
            },
            body: JSON.stringify(request || {})
        };
    };
    BaseBetsApiClient.prototype.executeRequest = function (url, fetchOptions) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var fetchUrl, options, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        fetchUrl = this.configuration.basePath + url;
                        options = this.getFetchOptions(fetchOptions.request);
                        if (options.method === 'GET' || options.method === 'HEAD') {
                            delete options.body;
                        }
                        return [4 /*yield*/, this.ajaxService.send(fetchUrl, options)];
                    case 1:
                        response = _a.sent();
                        if (!(response.status >= 200 && response.status < 300)) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.json()];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3: throw response;
                }
            });
        });
    };
    BaseBetsApiClient.prototype.refreshToken = function (token) {
        this.configuration.accessToken = token;
        return this;
    };
    return BaseBetsApiClient;
}());
export { BaseBetsApiClient };
//# sourceMappingURL=BaseBetsApiClient.js.map